import ConfigDB from "../../../Config/ThemeConfig";
import { hexToRgb } from "../../../Utils/helper/HexToRgb";

const primary = ConfigDB.color.primary_color;
const secondary = ConfigDB.color.secondary_color;

export const sparklingOptions = {
  responsive: true,
  plugins: {
    legend: { display: false },
    title: {
      display: false,
    },
    tooltip: {
      enabled: false,
      position: "nearest",
      appendToBody: false,
    },
  },
  scales: {
    x: {
      display: false,
    },
    y: { stacked: false, display: false },
  },
};

export const WidgetCardChart = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Dataset 1",
      data: [3200, 2500, 4000, 3000, 4500, 2000, 1000],
      backgroundColor: primary,
      stack: "combined",
      type: "bar",
      barThickness: 4,
      maxBarThickness: 5,
    },
    {
      label: "Dataset 2",
      data: [5000, 5000, 5000, 5000, 5000, 5000, 5000],
      backgroundColor: `rgba(${hexToRgb(primary)}, 0.1)`,
      barThickness: 4,
      maxBarThickness: 5,
      stack: "combined",
      type: "bar",
    },
  ],
};
export const WidgetCardChart2 = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Dataset 1",
      data: [3200, 2500, 4000, 3000, 4500, 2000, 1000],
      backgroundColor: secondary,
      stack: "combined",
      type: "bar",
      barThickness: 5,
      maxBarThickness: 5,
    },
    {
      label: "Dataset 2",
      data: [5000, 5000, 5000, 5000, 5000, 5000, 5000],
      backgroundColor: `rgba(${hexToRgb(secondary)}, 0.1)`,
      barThickness: 5,
      maxBarThickness: 5,
      stack: "combined",
      type: "bar",
    },
  ],
};

export const radialChart = {
  series: [65],
  chart: {
    height: 120,
    type: "radialBar",
    offsetX: -20,
    offsetY: -15,
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: "55%",
      },
      track: {
        background: "var(--theme-default)",
        opacity: 0.2,
      },
      dataLabels: {
        value: {
          color: "var(--tag-text-color--edit)",
          fontSize: "20px",
          show: true,
          offsetY: -12,
        },
      },
    },
  },
  colors: ["var(--theme-default)"],

  stroke: {
    lineCap: "round",
  },
};

export const radialChart_1 = {
  series: [80],
  chart: {
    height: 120,
    type: "radialBar",
    offsetX: -20,
    offsetY: -15,
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: "55%",
      },
      track: {
        background: "var(--theme-secondary)",
        opacity: 0.2,
      },
      dataLabels: {
        value: {
          color: "var(--tag-text-color--edit)",
          fontSize: "20px",
          show: true,
          offsetY: -12,
        },
      },
    },
  },
  colors: ["var(--theme-secondary)"],

  stroke: {
    lineCap: "round",
  },
};
